/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosAsset, CosmosCarousel, OptimizedCosmosAssetFragment } from "@components/elements";
import { css, cx } from "@panda/css";
import { Box } from "@panda/jsx";

export const styled = css({
	flex: "50%",
	position: "relative",

	"& .image-holder": {
		aspectRatio: "16/9",
		position: "relative",
		width: "100vw",
		borderRadius: "eds.dimension.24",
		overflow: "hidden",
		maxWidth: "100%",
	},

	"& .cosmos-asset, & .cosmos-video-embed": {
		position: "relative",
		zIndex: 2,
		w: "full",
		h: "full",
		objectFit: "cover",
	},

	"& .cosmos-attribution": {
		zIndex: 3,
	},

	"& .cosmos-carousel-viewport": { maxWidth: "full", overflow: "hidden", paddingInline: "0" },
	"& .cosmos-carousel-dots": {
		position: "absolute",
		bottom: "eds.dimension.40",
	},
});

export const slideAssetStyle = css({
	height: "100%",
	flexShrink: "0",
	minWidth: "0",
	objectFit: "cover",
	borderRadius: "eds.borderRadius.24",
	smDown: {
		borderRadius: "eds.borderRadius.12",
	},
});

export interface ContentSliderAssetMediaProps {
	assets?: OptimizedCosmosAssetFragment[] | null;
	isFirstSection?: boolean;
}

export const ContentSliderAssetMedia = ({
	assets,
	isFirstSection,
}: ContentSliderAssetMediaProps): React.JSX.Element | null => {
	if (!assets) return null;

	return (
		<Box className={cx("cntent-slider-asset-media", styled)}>
			<CosmosCarousel
				loop={true}
				buttonPosition="inside"
				dots={true}
				scaledRatio="1"
				slides={assets.map((asset: OptimizedCosmosAssetFragment) => (
					<div className="image-holder" key={asset.id}>
						<CosmosAsset className={cx("cosmos-asset", slideAssetStyle)} asset={asset} eager={isFirstSection} />
					</div>
				))}
				buttons={true}
				buttonSize="small"
			/>
		</Box>
	);
};
